import * as React from "react";
import * as ReactDOM from "react-dom";
import { TooltipControl, Borders } from "../../../../Intercom.ReactUI/Views/TooltipControl";

export interface BlockRowInputTooltipDisposer {
    (): void;
}

export interface BlockRowInputLabelProps extends React.Props<BlockRowInputLabel> {
    text: string;

    for?: string;
    tip?: string;
    tipAsHtml?: boolean;
    required?: boolean,
    onTooltipVisibilityChanged?: (visible: boolean, closeTip: BlockRowInputTooltipDisposer) => void;
}

interface BlockRowInputLabelState {
    showTooltip?: boolean;
}

export class BlockRowInputLabel extends React.Component<BlockRowInputLabelProps, BlockRowInputLabelState> {
    private _onWindowClickHandler: () => void;

    constructor(props: BlockRowInputLabelProps) {
        super(props);

        this._onWindowClickHandler = this._onWindowClick.bind(this);

        this.state = {
            showTooltip: false
        };
    }

    public componentWillUnmount() {
        window.removeEventListener("click", this._onWindowClickHandler);
    }

    private onHideToolTip = () => {
        this._setTooltipVisibility(false, false);
    }

    private notifyTooltipVisibilityChanged() {
        if (!this.props.onTooltipVisibilityChanged) {
            // TODO: add default behavior for modeless tooltip (single tip shown at any time, click off will dismiss
            return;
        }

        this.props.onTooltipVisibilityChanged(
            this.state.showTooltip,
            this.state.showTooltip ? this.onHideToolTip : null);
    }

    /**
     * Set the tooltip visibility and, optionally, invoke onTooltipVisibilityChanged.
     * @param visible New visibility state for the tooltip.
     * @param shouldNotifyChanged -should onTooltipVisibilityChanged be invoked.
     */
    private _setTooltipVisibility(visible: boolean, shouldNotifyChanged: boolean) {
        if (this.state.showTooltip === visible) {
            return;
        }

        this.setState({ showTooltip: visible }, () => {
            // When showTooltip is true the 'tooltip' control will be added - need to change it's position.
            const toolTipControl = this.refs['tooltip'] as TooltipControl;
            if (toolTipControl) {
                toolTipControl.anchorTo($(this.refs['upper-label'] as HTMLElement));

                window.addEventListener("click", this._onWindowClickHandler);
            }
            else {
                window.removeEventListener("click", this._onWindowClickHandler);
            }

            if (shouldNotifyChanged) {
                this.notifyTooltipVisibilityChanged();
            }
        });
    }

    private renderTooltip(): JSX.Element {
        let tipText = this.props.tip;
        if (!tipText || !this.state.showTooltip) {
            return null;
        }

        let tipContent: JSX.Element = null;
        if (this.props.tipAsHtml) {
            tipContent = (<span dangerouslySetInnerHTML={{ __html: tipText }}></span>);
        } else {
            tipContent = <span>{tipText}</span>;
        }

        return <TooltipControl
            ref='tooltip'
            tipId='fieldTooltip'
            anchorBorder={Borders.Left}
            className={tipText ? "modeless" : "hidden"}>
            {tipContent}
        </TooltipControl>;
    }

    public render() {
        return <label
            tabIndex={0}
            ref="upper-label"
            htmlFor={this.props.for}
            className={"label-above " + (this.props.tip ? "icon-help" : "")}
            onMouseEnter={_.debounce(x => this._setTooltipVisibility(true, true), 100, true)}
            onMouseLeave={_.debounce(x => this._setTooltipVisibility(false, true), 100, true)}
            onFocus={_.debounce(x => this._setTooltipVisibility(true, true), 100, true)}
            onBlur={_.debounce(x => this._setTooltipVisibility(false, true), 100, true)}
        >
            {this.props.required ? '*' : ''}&nbsp;{this.props.text}
            {this.renderTooltip()}
        </label>;
    }

    private _onWindowClick() {
        this._setTooltipVisibility(false, true);
    }
}



// WEBPACK FOOTER //
// ./Client/Views/Shared/BlockRowInputLabel.tsx